import { createContext } from 'react'

import type { Meta } from '../../generated/frontend'

export const ArticleTemplateContext = createContext<{
  meta: Meta
}>({
  meta: {
    canonical: '',
    contentId: '',
    dataLayer: '',
    desc: '',
    facebookDesc: '',
    facebookImage: '',
    facebookTitle: '',
    fbAppId: '',
    headCodeBlock: '',
    keywords: [],
    pageType: '',
    publishedDate: '',
    taxonomyHierarchy: {
      category: '',
      subVertical: '',
      superCategory: '',
      vertical: '',
    },
    title: '',
    twitterDesc: '',
    twitterImage: '',
    twitterTitle: '',
    updatedDateTime: Infinity,
    publishedDateTime: Infinity,
    systemContentPublishedDate: '',
    systemContentUpdatedDate: '',
    glideCurationDate: '',
    frequencyOfUpdate: '',
    reviewSchema: '',
    significantUpdate: '',
  },
})
